<template>
  <div class="modify-page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >信息修改
    </navigation>
    <div class="form-container">
      <div class="divider"></div>
      <template v-if="showCard">
        <div class="add-header ">
          <h3>请上传收款卡照片</h3>
          <p>仅用于平台审核，请确保证件边框完整、字迹清晰</p>
        </div>
        <div class="upload-container">
          <van-uploader
            v-model="PAYMENT_CARD_PHOTO"
            :max-count="5"
            multiple
            :max-size="10 * 1024*1024"
            @oversize="onOversize"
            :after-read="(e)=>afterRead(e,'PAYMENT_CARD_PHOTO')"
            accept="image/*"
            :class="isMultiple(PAYMENT_CARD_PHOTO.length)"
          >
            <img src="./images/img_zhaopian@2x.png" v-if="!PAYMENT_CARD_PHOTO.length" class="upload-bg">
            <template v-else>
              <img
                src="./images/icon_add@2x.png"
                class="icon-add"
              >
              <p>可再添加{{5-PAYMENT_CARD_PHOTO.length}}张</p>
            </template>
          
          </van-uploader>
        </div>
      </template>

      <template v-if="showLoan">
        <div class="add-header ">
          <h3>请上传放款借据银行流水</h3>
        </div>
        <div class="upload-container">
          <van-uploader
            v-model="LOAN_HISTORY_SCREEN"
            :max-count="5"
            multiple
            :max-size="10 * 1024*1024"
            @oversize="onOversize"
            :after-read="(e)=>afterRead(e,'LOAN_HISTORY_SCREEN')"
            accept="image/*"
            :class="isMultiple(LOAN_HISTORY_SCREEN.length)"
          >
            <img src="./images/img_zhaopian@2x.png" v-if="!LOAN_HISTORY_SCREEN.length" class="upload-bg">
            <template v-else>
              <img
                src="./images/icon_add@2x.png"
                class="icon-add"
              >
              <p>可再添加{{5-LOAN_HISTORY_SCREEN.length}}张</p>
            </template>
          
          </van-uploader>
        </div>

      </template>
    </div>

    <div class="control-box">
      <nd-button
        class="btn"
        :disabled="isDisabled"
        @click="next"
      >确认提交</nd-button>
    </div>

  </div>
</template>


<script>
import uploadMixins from '@/assets/uploadMixins'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      selected: false,
      PAYMENT_CARD_PHOTO: [],
      LOAN_HISTORY_SCREEN: [],
      needProvide: []
    }
  },
  mixins: [uploadMixins],
  mounted () {
    this.getConfig()
    this.$bus.$emit('ready')
  },
  computed: {
    isDisabled () {
      return (this.showCard && !this.PAYMENT_CARD_PHOTO.length) || (this.showLoan && !this.LOAN_HISTORY_SCREEN.length)
    },
    showCard () {
      return this.needProvide.includes('PAYMENT_CARD_PHOTO')
    },
    showLoan () {
      return this.needProvide.includes('LOAN_HISTORY_SCREEN')
    }
  },
  methods: {
    isMultiple (lth) {
      return lth ? 'multiple-item' : 'van-uploader-item'
    },
    ...mapActions('modify', ['uploadImage', 'getChangeConfig']),
    async getConfig () {
      const { success, data } = await this.getChangeConfig()
      if (success) {
        this.needProvide = data.needProvide || []
      }
    },
    // 一张或者多张图片上传
    async afterRead (file, type) {
      await this.uploadImg(file, type)
    },
    paramsInit (type) {
      if (!this[type]?.length) return
      return this[type].map(item => {
        return {
          url: item.reqUrl,
          imageType: type
        }
      })
    },
    async next () {
      const images = []
      if (this.showCard) {
        images.push(...this.paramsInit('PAYMENT_CARD_PHOTO'))
      }
      if (this.showLoan) {
        images.push(...this.paramsInit('LOAN_HISTORY_SCREEN'))
      }
     
      const { success } = await this.uploadImage({ images })
      if (success) {
        this.$message('提交成功', 2000)
        this.$router.go(-1)
      }
    }
     
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.modify-page {
  min-height: 100vh;
  padding-bottom: 20px;
  width: 750px;
  overflow: hidden;
  .divider {
    border-top: 20px solid #f8f8f8;
    height: 0px;
    font-size: 0px;
  }

  .btn {
    margin: 80px auto 20px;
  }
  .add-header {
    padding: 40px;
    padding-bottom: 0;
    h3 {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    p {
      color: #999;
      font-size: 24px;
    }
  }
  .upload-container {
    margin: 40px;
    position: relative;
    min-height: 300px;
   
    /deep/.van-uploader__preview-image {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      overflow: hidden;
    }
    /deep/.van-uploader__mask{
      border-radius: 10px;
    }
    .multiple-item {
      width: 110%;
      /deep/.van-uploader__preview {
        width: 210px;
        height: 210px;
        border-radius: 10px;
        margin-right: 23px;
        margin-bottom: 23px;
        /deep/.van-uploader__preview-imag img {
          object-fit: cover;
        }
      }

      /deep/.van-uploader__preview-delete {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        top: calc(100% - 20px);
        left: calc(100% - 20px);
        background: rgba(0,0,0,0.5);
        position: absolute;
      }

      /deep/.van-uploader__input-wrapper {
        width: 210px;
        height: 210px;
        border: 2px dashed #ccc;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 10px;
        p {
          font-size: 24px;
          color: #666;
        }
      }
      /deep/.van-uploader__preview-delete-icon {
        font-size: 50px;
        position: initial;
      }
      .icon-add {
        width: 60px;
        height: 60px;
      }
      p {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }

    .van-uploader-item {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      .upload-bg {
        width: 100%;
        height: 100%;
      }
      /deep/.van-uploader__wrapper,
      /deep/.van-uploader__preview,
      /deep/.van-uploader__preview-image,
      /deep/.van-uploader__preview-imag img,
      /deep/.van-uploader__input-wrapper {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      /deep/.van-uploader__preview-imag img {
        object-fit: cover;
      }
      /deep/.van-uploader__preview-delete {
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        top: calc(100% - 20px);
        left: calc(100% - 20px);
        background: rgba(0,0,0,0.5);
        position: absolute;
      }
      /deep/.van-uploader__preview-delete-icon {
        font-size: 50px;
        position: initial;
      }
    }
  }
}
</style>